import EntityStore from "./EntityStore";

export default class EntityWithIdStore extends EntityStore {
    getEntityId(entity)
    {
        return entity.id
    }
}



// WEBPACK FOOTER //
// ./web/js/store/EntityWithIdStore.js